export default "__VITE_ASSET__a7ed40b4__"